import React from 'react';

import { IGatsbyImageData } from 'gatsby-plugin-image';

import classnames from 'classnames';

import { Image } from 'common/components';
import { IBlockItem } from 'common/interfaces/landing.interface';

import Quote from 'icons/quote-old.svg';

import './LandingQuote.scss';

interface Props {
  noBackground?: boolean;
  title?: string;
  quote: IBlockItem;
  avatarSrc?: IGatsbyImageData;
  link?: {
    field_title: string;
    field_link: string;
  };
  hasFontSometypeMono?: boolean;
}

export const LandingQuote = ({
  title,
  quote,
  avatarSrc,
  link,
  noBackground = false,
  hasFontSometypeMono = false,
}: Props) => (
  <div className={classnames('quote-block quote-block-background', { 'no-background': noBackground })}>
    {title && <h4 className="quote-block-title">{title}</h4>}
    <div className="quote-block-text">
      <Quote />
      <p className={`medium-bold ${hasFontSometypeMono ? 'has-font-sometype-mono' : ''}`}>
        {quote.field_description?.value}
      </p>
    </div>
    <div className="quote-block-author">
      {avatarSrc && (
        <Image
          image={avatarSrc}
          alt={quote.field_image.alt}
          className="quote-block-author-img quote-block-round-image"
        />
      )}
      <div className="quote-block-author-text">
        <p className="medium-bold">{quote.field_title}</p>
        <p className="caption quote-block-position">{quote.field_position}</p>
      </div>
    </div>
    {link && (
      <div className="quote-block-link btn-text">
        <a href={link.field_link || ''} target="_blank" rel="noreferrer" aria-label="See more on the link">
          {link.field_title}
        </a>
      </div>
    )}
  </div>
);
